import { APP_VERSION } from "config/version";

/**
 * A assinatura da marca: a tagline do wordmark do topo mais a versão do build.
 *
 * É o fecho das telas em que o rodapé completo seria demais -- confirma onde a pessoa está
 * sem acrescentar nada para tocar. Vive em dois lugares, por isso é componente: na web mobile
 * fecha as páginas internas (components/Footer.jsx); no app, onde página nenhuma tem rodapé,
 * fecha o menu sanduíche (components/NavBar.jsx).
 *
 * A versão fica aqui porque, nesses dois contextos, esta é a única parte do rodapé que
 * aparece -- e é daqui que suporte/dev leem o número no print de quem tem problema.
 * text-dark/20 deixa ela abaixo até da tagline: presente para quem procura, invisível para
 * quem não. A tagline usa text-dark/35 pelo motivo oposto ao text-muted de t-apoio, que
 * ficava fraco demais para ser a única coisa no fim da página.
 *
 * `className` é só medida do wrapper (padding, md:hidden, mt-auto): o visual dos dois lugares
 * tem que sair daqui. De propósito sem bg-white nem border-t -- essas duas classes são o que
 * faz um bloco ler como seção à parte, e isto é texto solto no fim, não uma seção nova.
 */
function AssinaturaMarca({ className = "" }) {
  return (
    <div className={`text-center ${className}`}>
      <p className="text-sm text-dark/35">Nova Faxina - Tudo simples. Tudo limpo.</p>
      <span className="mt-1 block text-xs text-dark/20">{APP_VERSION}</span>
    </div>
  );
}

export default AssinaturaMarca;
